import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=70f7c420"
import script from "./Dashboard.ts?vue&type=script&lang=ts&external"
export * from "./Dashboard.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports